import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import FoodMenuFields from './FoodMenuFields'

export const FoodMenuEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <FoodMenuFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default FoodMenuEdit
